<div class="eb-date-picker">
  <div class="eb-date-picker-input">
    <input
      type="text"
      [attr.data-cy]="startDate | cxDate: 'mediumDate' : 'UTC'"
      ngbDatepicker
      #d="ngbDatepicker"
      placeholder="{{ 'common.selectDate' | cxTranslate }}"
      [value]="startDate | cxDate: 'mediumDate' : 'UTC'"
      [disabled]="isLoading"
      readonly
    />
    <eb-spinner *ngIf="isLoading" size="1"></eb-spinner>
    <em *ngIf="!isLoading" class="far fa-calendar-alt"></em>
  </div>
  <div class="eb-date-picker-select">
    <ngb-datepicker
      #d
      *ngIf="render"
      [ngClass]="{ 'date__input--hidden': hideInput }"
      [(ngModel)]="selectedDate"
      (ngModelChange)="dateChange.emit($event)"
      [minDate]="pickerMinDate"
      [startDate]="selectedDate"
      [markDisabled]="disableDays"
      [navigation]="navigation"
    ></ngb-datepicker>
  </div>
</div>
